import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "au-menu-btn__icon" }
const _hoisted_2 = { class: "au-menu-btn__label" }

import { hapticsImpactLight } from 'util/device-util';
import { useModule } from 'src/modules/modules';


export default /*#__PURE__*/_defineComponent({
  __name: 'menu-button',
  props: {
    iconClass: null,
    label: null,
    toScene: null,
    audioKey: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as {
    iconClass: string,
    label: string,
    toScene?: string,
    audioKey?: string
}

const { global, audio } = useModule();



const handleClick = () => {
    hapticsImpactLight();
    audio.play(props.audioKey ?? 'FX_menu_btn');
    if (props.toScene){
        global.startScene(props.toScene);
    } else {
        emit('click');
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _mergeProps(_ctx.$attrs, {
    class: "au-menu-btn",
    onClick: handleClick
  }), [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("i", {
        class: _normalizeClass(__props.iconClass)
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.label), 1)
  ], 16))
}
}

})